import strFunc from "@/lib/lyg/string";
import TextAreaComponent from "@/pcomponents/common/crud/write/textarea";

function SmsRowArea(props: any) {
  let myProps = {
    sms_data: {},
    row_num: 0,
    sms_data_arr: [],
    set_sms_data_arr: (inData: any) => { },
    check_row_num_arr: [],
    set_check_row_num_arr: (inData: any) => { },
    ...props
  };
  let sms_data = myProps.sms_data;
  let sms_data_arr = myProps.sms_data_arr;
  let row_num = myProps.row_num;

  const onChangeInput = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;
    if (strFunc.is_empty(sms_data_arr[row_num])) {
      return false;
    }
    let change_row_data = sms_data_arr[row_num];
    change_row_data[name] = value;
    sms_data_arr[row_num] = change_row_data;
    myProps.set_sms_data_arr(sms_data_arr);
  };

  return (
    <div className="mt-2" style={{ background: "#f5f5f5", padding: "10px", borderRadius: "5px" }}>
      <div className="mt-1">
        {row_num + 1}. {sms_data["user_name"]}
      </div>
      <div className="mt-1">
        핸드폰: <input type="row-input" name="phone_num" value={sms_data["phone_num"]}
          onChange={onChangeInput}
          autoComplete="off"
          style={{ width: "200px", textAlign: "center" }} />
      </div>
      <div className="mt-1">
        <div>
          메세지:
        </div>
        <TextAreaComponent
          name="content"
          value={sms_data["content"]}
          onChange={onChangeInput}
          style={{ padding: "8px" }}
        ></TextAreaComponent>
      </div>
    </div>
  );
};
export default SmsRowArea;